import React from "react"
import styled from "styled-components"
import TextBody from "./TextBody"

const Element = styled(TextBody)`
  font-weight: 400;
  line-height: 2;
  color: var(--textNormal);
  margin-top: ${props => props.theme.spacing[3]};
  margin-bottom: ${props => props.theme.spacing[6]};
  font-size: ${props => props.theme.fontSize["base"]};
`

const Paragraph = ({ children, color, tint = "default", ...props }) => (
  <Element as="p" color={color} tint={tint} {...props}>
    {children}
  </Element>
)

export default Paragraph
